export interface SlugOption {
	label: string;
	value: string;
}

/**
 * Without the fallback entry a stored slug that no longer exists (renamed or
 * moved scene, imported legacy data) would render as an empty dropdown and
 * read as "nothing is set".
 */
export function slugOptions(slugs: string[], current?: string | null): SlugOption[] {
	const options = slugs.map(slug => ({ label: slug, value: slug }));
	if (current && !slugs.includes(current)) {
		options.unshift({ label: `${current} (missing)`, value: current });
	}
	return options;
}
